export default __webpack_public_path__ + "static/media/Blog.a265a0dd.svg";